// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1Jt4g","box":"WorkspacesBox_box__2WLtu","node":"WorkspacesBox_node__2Xp2H"};